import { ListSortDirection, Sort } from "../../models/api/sort";
import { EventTypeDTO, EventTypeSTO } from "../../models/event-types";
import { BaseApiService } from "../base/base-api.service";

export class EventTypesApiService extends BaseApiService<EventTypeDTO, EventTypeSTO> {
  constructor() {
    super({
      servicePath: "/EventTypes",
      loadItemsPath: "/GetEventTypes",
      saveItemsPath: "/SaveEventTypes",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
